module.exports = __webpack_public_path__ + "static/media/blocker_brain.ccb9c376.png";